import {
  getColumnsWrapperStyle,
  getColumnsInnerStyle,
  getColumnStyle,
} from "./style";
import { parseLiquidObject } from "@/Apps/Pages/Page/LiquidRenderer";

export const Columns = (props) => (
  <div data-testid="WC-COLUMNS-LIVE" style={getColumnsWrapperStyle(props)}>
    <div style={parseLiquidObject(getColumnsInnerStyle(props))}>{props.children}</div>
  </div>
);

export const Column = (props) => {
  return <div style={parseLiquidObject(getColumnStyle(props))}>{props.children}</div>;
};

export default Columns;
